import script from "./SelectModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__